import { createContext, useContext, useMemo } from 'react';
import { useResponsive } from "../contexts";
import { PreviewState } from "./ClientOnboarding.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const CobConfigContext = /*#__PURE__*/createContext(undefined);
export function CobConfigProvider(props) {
  const {
    relationship,
    children,
    isPreviewModal,
    previewState,
    originalPreviewState,
    isFromDraft
  } = props;
  const {
    isMobile
  } = useResponsive();
  const value = useMemo(() => ({
    relationship,
    isPreviewModal: !!isPreviewModal,
    isPreview: !!previewState,
    // We do not have a design for setup brand in mobile.
    isSetupBrand: previewState === PreviewState.SetupBrand && !isMobile,
    originalPreviewState,
    isFromDraft
  }), [relationship, previewState, isPreviewModal, isMobile, originalPreviewState, isFromDraft]);
  return /*#__PURE__*/_jsx(CobConfigContext.Provider, {
    value: value,
    children: children
  });
}
export function useCobConfig() {
  const context = useContext(CobConfigContext);
  if (!context) throw new Error('useCobConfig must be used within a CobConfigProvider');
  return context;
}